import { render, staticRenderFns } from "./editCliente.vue?vue&type=template&id=06d5f884&scoped=true&"
import script from "./editCliente.vue?vue&type=script&lang=js&"
export * from "./editCliente.vue?vue&type=script&lang=js&"
import style0 from "./editCliente.vue?vue&type=style&index=0&id=06d5f884&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d5f884",
  null
  
)

export default component.exports